import { useSyncExternalStore } from "react";

export const isOnline = () =>
  typeof navigator === "undefined" || navigator.onLine !== false;

export const subscribeOnline = (listener) => {
  window.addEventListener("online", listener);
  window.addEventListener("offline", listener);
  return () => {
    window.removeEventListener("online", listener);
    window.removeEventListener("offline", listener);
  };
};

export const useOnline = () =>
  useSyncExternalStore(subscribeOnline, isOnline, () => true);
